export default {
  CABOTAGE: 'CABOTAGE', // Domestic market / AR
  REGIONAL: 'REGIONAL',
  INTERNATIONAL: 'INTERNATIONAL'
}
